import React, {FC, useState, useEffect} from "react"
import moment from "moment"

import FormattedMessage from "@irati/utils/lang"
import {Body, Label} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import theme from "@irati/ui/src/global/theme"
import workosService from "@irati/workos/services/workos"
import {Tooltip, OverlayPlacement} from "@irati/ui/src/Tooltip"
import {IconTypes} from "@irati/ui/src/Icon"
import authentication from "@irati/auth"
import Card from "@irati/ui/src/Layout/Card"
import Spacing from "@irati/ui/src/Spacing"

import {StyledIcon, StyledLink} from "./styled"

interface Props {
  show: boolean
  title: string
  onSubmit: (load: Promise<void>) => void
}

const SetupLink: FC<Props> = ({show, title, onSubmit}) => {
  const [link, setLink] = useState<string>()
  const [expiryDate, setExpiryDate] = useState<string>()
  const [isToday, setIsToday] = useState<boolean>()

  const generateSetupLink = () => {
    const load = workosService.generateSetupLinkCode(authentication.business().uuid).then((setupResponse) => {
      const date = moment.utc(setupResponse.expiresAt).local()
      const url = `${window.location.origin}/workOS-integrations-link?code=${setupResponse.code}`
      setExpiryDate(date.format("HH:mm"))
      setIsToday(date.format("D") === moment().local().format("D"))
      setLink(url)
    })
    onSubmit(load)
  }

  const handleOnClick = () => {
    navigator.clipboard.writeText(link!)
  }

  useEffect(() => {
    if (show) {
      generateSetupLink()
    }
    if (!show) {
      setLink(undefined)
      setExpiryDate(undefined)
    }
  }, [show])

  const expirationText = isToday
    ? "admin.components.integration.directorySync.hris.upsell.generateSetupLink.expireToday"
    : "admin.components.integration.directorySync.hris.upsell.generateSetupLink.expireTomorrow"

  return (
    <>
      {expiryDate && (
        <Card noBorder bgColor={theme.colors.utility.warning} padding={[1, 2]} marginBottom={2}>
          <Flex alignItems="flex-start">
            <Spacing marginTop={theme.spacing.half} marginRight>
              <StyledIcon color={theme.colors.filterChip} icon={IconTypes.circleAlertFill} size={20} />
            </Spacing>
            <Body color={theme.colors.filterChip} weight="bold">
              <FormattedMessage
                id={title}
                values={{
                  today: (
                    <Label color={theme.colors.filterChip} large weight="bold">
                      <FormattedMessage id={expirationText} values={{time: expiryDate}} />
                    </Label>
                  )
                }}
              />
            </Body>
          </Flex>
        </Card>
      )}
      {link && (
        <Tooltip
          placement={OverlayPlacement.Right}
          tooltipChildren={
            <Body small>
              <FormattedMessage id="admin.components.integration.directorySync.hris.upsell.generateSetupLink.copyLink" />
            </Body>
          }>
          <StyledLink cta marginBottom onClick={handleOnClick}>
            {link}
          </StyledLink>
        </Tooltip>
      )}
    </>
  )
}

export default SetupLink
